import React, { useState } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { toast } from 'react-hot-toast';
import { Eye, Pencil, Trash2 } from 'lucide-react';

const DraftsSection = ({ 
  user,
  drafts,
  setDrafts,
  setPreviewDraft,
  loadReport,
  deleteDraft,
  renameDraft
}) => {
  const [editingDraftId, setEditingDraftId] = useState(null);

  const loadDrafts = async () => {
    try {
      const draftsRef = collection(db, 'drafts');
      const draftsQuery = query(
        draftsRef,
        where('createdBy', '==', user?.uid), // Only get user's drafts
        orderBy('savedAt', 'desc')
      );
      const snapshot = await getDocs(draftsQuery);
      const drafts = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setDrafts(drafts);
    } catch (error) {
      console.error('Error loading drafts:', error);
      toast.error('Error loading drafts');
    }
  };

  return (
    <div className="mt-8 pt-6 border-t border-slate-200">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-slate-700">Saved Drafts</h3>
        <button
          onClick={loadDrafts}
          className="text-sm text-blue-500 hover:text-blue-600"
        >
          Refresh
        </button>
      </div>
      <div className="space-y-2">
        {drafts.length > 0 ? (
          drafts.map(draft => (
            <div key={draft.id} className="p-3 bg-slate-50 rounded-lg flex justify-between items-center hover:bg-slate-100 transition-colors">
              <div className="flex-1 min-w-0 mr-4">
                {editingDraftId === draft.id ? (
                  <input
                    type="text"
                    className="w-full px-2 py-1 border rounded"
                    defaultValue={draft.clientName}
                    onBlur={(e) => renameDraft(draft.id, e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') renameDraft(draft.id, e.target.value);
                      if (e.key === 'Escape') setEditingDraftId(null);
                    }}
                    autoFocus
                  />
                ) : (
                  <>
                    <p className="font-medium truncate">
                      {draft.propertyAddress || draft.clientName || 'Untitled Draft'}
                    </p>
                    <p className="text-sm text-slate-500">
                      Saved {new Date(draft.savedAt).toLocaleDateString()}
                    </p>
                  </>
                )}
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={() => setPreviewDraft(draft)}
                  className="text-slate-500 hover:text-slate-700"
                  title="Preview draft"
                >
                  <Eye className="h-4 w-4" />
                </button>
                <button
                  onClick={() => {
                    toast.success('Draft loaded for editing');
                    loadReport(draft);
                  }}
                  className="text-blue-500 hover:text-blue-600 flex items-center gap-1"
                  title="Edit draft"
                >
                  <Pencil className="h-4 w-4" />
                  <span className="text-sm">Edit</span>
                </button>
                <button
                  onClick={(e) => deleteDraft(draft.id, e)}
                  className="text-red-500 hover:text-red-600"
                  title="Delete draft"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="text-slate-500 text-center py-4">No saved drafts</p>
        )}
      </div>
    </div>
  );
};

export default DraftsSection; 